module.exports = __webpack_public_path__ + "img/starfsmannahald.d6d071b8.svg";